import DOMPurify from "dompurify";

export const renderSanitizedHTML = (html: string) => ({
    dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, ADD_TAGS: ["iframe"] }),
    },
});
